// extracted by mini-css-extract-plugin
module.exports = {"anchor":"anchor_anchor__1zu5G","sliderWrap":"anchor_sliderWrap__3X5cg","selectWrap":"anchor_selectWrap__yX8_S"};